var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data),function(ref,i){
var number = ref.number;
var text = ref.text;
return _c('NumberRow',{key:("numbers-row-" + i),staticClass:"mb-12 last:mb-0",attrs:{"number":number,"text":text}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }